import { render, staticRenderFns } from "./readMode-editor.vue?vue&type=template&id=58a24a3b&scoped=true&"
import script from "./readMode-editor.vue?vue&type=script&lang=js&"
export * from "./readMode-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a24a3b",
  null
  
)

export default component.exports